import { colors } from '@creditornot/cb-ingredients';
import styled from 'styled-components';

import yuhoImage from './../../../images/yuho.png';

export const YuhoCampaignBanner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 12px 84px 12px 16px;
  height: 72px;
  background: ${colors.wolt8};
  border-radius: 8px;
  color: ${colors.wolt100};
  overflow: hidden;

  &::before,
  &::after {
    content: '';
    position: absolute;
  }

  &::before {
    inset-inline-end: -40px;
    inset-block-end: -10px;
    width: 120px;
    height: 120px;
    box-shadow: 0 4px 40px 0 ${colors.wolt16} inset;
    border-radius: 50%;
    opacity: 1;
  }

  &::after {
    inset-inline-end: 0;
    inset-block-end: 6px;
    width: 64px;
    height: 64px;
    background: url(${yuhoImage}) no-repeat center;
  }
`;
